import "./TaskCount.css";
import classNames from "classnames";
import { useMemo } from "react";

import { LISCaseList } from "pwapi";

// TODO: this is possibly overkill.  processes array could already be sufficiently trimmed.  review later
export const transformCases_excludeCompleteProcesses = (cases: LISCaseList[]) =>
  cases
    .map((c) => ({
      ...c,
      work_processes: c.work_processes.filter(
        ({ completed_at }) => !completed_at
      ),
    }))
    // Filter out any cases with no remaining tasks
    .filter(({ work_processes }) => !!work_processes.length);

const createMapStationTypeToTaskMeta: (cases: LISCaseList[]) => Record<
  string,
  {
    taskHeading: string;
    countableItems: [string, number][];
  }
> = (cases) => {
  // Mutate CaseList to filter
  const cases_processesIncomplete =
    transformCases_excludeCompleteProcesses(cases);

  const caseCount = cases_processesIncomplete.length;
  const specimenCount = cases_processesIncomplete.flatMap(
    (c) => c.specimens
  ).length;
  const blockCount = cases_processesIncomplete.flatMap((c) => c.blocks).length;

  const openCuttingTasksCount = cases_processesIncomplete.flatMap((c) =>
    c.work_processes.flatMap(({ tasks }) =>
      tasks.filter(
        ({ completed_at, type }) => !completed_at && type === "cutting"
      )
    )
  ).length;

  // const openOrdersCount = cases_processesIncomplete.flatMap(
  //   (c) => c.work_processes
  // ).length;

  return {
    grossing: {
      taskHeading: "Scan Requisition to Start",
      countableItems: [
        ["Cases", caseCount],
        ["Specimens to Gross", specimenCount],
      ],
    },
    embedding: {
      taskHeading: "Scan Cassette Before Embedding",
      countableItems: [["Blocks to Embed", blockCount]],
    },
    cutting: {
      taskHeading: "Scan Block to Start",
      countableItems: [["Slides to Cut", openCuttingTasksCount]],
    },
  };
};

interface TaskCountProps {
  cases: LISCaseList[];
  stationType: string;
}

const TaskCount: React.FC<TaskCountProps> = ({ cases, stationType }) => {
  const mapStationTypeToTaskMeta = useMemo(
    () => createMapStationTypeToTaskMeta(cases),
    [cases]
  );
  const { taskHeading, countableItems } = mapStationTypeToTaskMeta[stationType];

  const totalCountableItems = countableItems.reduce(
    (acc, [, countableItemQuantity]) => acc + countableItemQuantity,
    0
  );

  if (!totalCountableItems) return null;

  return (
    <div className={classNames("TaskCount", `TaskCount--${stationType}`)}>
      <h5 key={taskHeading} className="TaskCount__heading">
        {taskHeading}
      </h5>

      <div className="TaskCount__countable--row">
        {countableItems.map(([task, quantity]) => (
          <div className="TaskCount__countable--cell" key={`${task}`}>
            <span className="TaskCount__countable--task">{task}:</span>
            <span className="TaskCount__countable--quantity">{quantity}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskCount;
